export default __webpack_public_path__ + "static/media/courses.37597912.png";